import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { postContainerMessage, postNativeMessage } from './util/postMessage';
// import * as serviceWorker from './serviceWorker';
import BrowserLogger from 'alife-logger';
import VConsole from 'vconsole';

window.SCREEN_WIDTH = document.body.clientWidth;
window.postContainerMessage = postContainerMessage;
window.postNativeMessage = postNativeMessage;

window.addEventListener('error', function onError(e) {
  // Ignore ResizeObserver error
  if (e.message === 'ResizeObserver loop limit exceeded') {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
});

const BUILD_ENV = process.env.BUILD_ENV;
if (BUILD_ENV === 'prd') {
  BrowserLogger.singleton({
    pid: 'j8017dm5g5@f45ad16d01be5d5',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
  });
}
if(BUILD_ENV === 'dev'){
  const vConsole = new VConsole();
}

const render = (Component) => {
  ReactDOM.render(
    <React.Fragment>
      <Component />
    </React.Fragment>,
    document.getElementById('root')
  );
};

render(App);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
